import React from 'react';
import {
  Major1, Major2,
  ProductIcon1, ProductIcon2, ProductIcon3, ProductIcon4, ProductIcon5,
  landingPageone, landingPagfour, landingPagthree, landingPagtwo,
  Tech1, Tech3, Tech4, landing
} from '../assests';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useNavigate } from 'react-router-dom'


const Home = () => {
    const navigate = useNavigate();
  const settings = {
    dots: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const productData = [
    { img: ProductIcon1, label: "Blower Cover" },
    { img: ProductIcon2, label: "Duct Air" },
    { img: ProductIcon3, label: "Exhaust Manifold" },
    { img: ProductIcon5, label: "Racing Car Fender" },
    { img: landingPageone, label: "Engine Cover" },
    { img: landingPagfour, label: "Engine Cover" },
    { img: landingPagthree, label: "Bus Front Show" },
    { img: landingPagtwo, label: "FRP Engine Hood" },
  ];
  const handleProductClick = (productLabel) => {
    console.log("Product label clicked:", productLabel);
    const slug = productLabel.toLowerCase().replace(/ /g, '-');
    navigate('/Screens/ProductPage'); // dynamic route
  };

  return (
    <div style={{ backgroundColor: "#29B06710" }}>
      {/* Home Image */}
      <div>
        <img src={landing} style={{ height: "730px", width: "100%" }} alt="Landing" />
      </div>

      {/* Products We Offer */}
      <div style={{ padding: "40px 20px", backgroundColor: "#fff" }}>
        <h2 style={{ textAlign: "center", marginBottom: 30, color: "#333", fontSize: 26 }}>
          Products We Offer
        </h2>
        <Slider {...settings}>
          {productData.map((item, index) => (
            <div
              key={index}
              style={{ padding: 10 }}
              onClick={() => handleProductClick(item.label)}
            >
              <div
                style={{
                  backgroundColor: "#f9f9f9",
                  borderRadius: 12,
                  padding: 20,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  transition: "transform 0.3s",
                  textAlign: "center",
                  cursor: "pointer",
                  height: 320,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
                onMouseEnter={e => e.currentTarget.style.transform = "scale(1.05)"}
                onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
              >
                <img
                  src={item.img}
                  alt={item.label}
                  style={{
                    height: 180,
                    width: "100%",
                    objectFit: "contain",
                    marginBottom: 15,
                  }}
                />
                <p style={{ fontSize: 16, fontWeight: 600, color: "#444", margin: 0 }}>
                  {item.label}
                </p>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* TECHNOLOGY */}
      <div>
        <h1 style={{ textAlign: "center" }}>TECHNOLOGY</h1>
        <div style={{ flexDirection: "row", display: "flex", padding: 15, justifyContent: "center", alignItems: "center" }}>
          <div style={{ padding: 5, textAlign: "left", width: 500, marginRight: 100 }}>
            <h3 style={{ textAlign: "center" }}>FRP - Fiber Reinforced Plastics</h3>
            <p>Fibre Reinforced Plastic or FRP is a composite material consisting of reinforcing fibres thermosetting resins and other materials such as fillers and pigments may also be present.</p>
            <p>Fiber Reinforced Plastic (FRP) is one of our areas of expertise since last 20 yrs.</p>
            <p>Installed Capacity - 800 Ton per annum</p>
            <p>Components being manufactured are in the following slides</p>
            <p>We are manufacturing automobile and engineering parts</p>
          </div>
          <div>
            <img src={Tech1} style={{ height: 200, width: 500 }} alt="Tech1" />
          </div>
        </div>

        <div style={{ flexDirection: "row", display: "flex", padding: 15, justifyContent: "center", alignItems: "center" }}>
          <div>
            <img src={Tech3} style={{ height: 200, width: 500, marginRight: 100 }} alt="Tech3" />
          </div>
          <div style={{ padding: 10, textAlign: "left", width: 500 }}>
            <h3 style={{ textAlign: "center" }}>Plastic Injection Molding</h3>
            <p>Plastic Injection molding is the fastest way to develop quality plastic products and these products are widely used in different sectors like automobile, electrical, bus body interior and piping industry etc.</p>
            <p>AECPL has acquired mastery in this technology. We are capable of producing 200 Tons of injection molded components with the use of multiple IM machines having capacity from 25 Tons to 450 tons. We have developed products parts weighing from 0.5 gms to 1.5 kg.</p>
            <p>This is our prime focus area and it has enabled us entering US market by helping us winning order from US major GreenStar Inc.</p>
          </div>
        </div>

        <div style={{ flexDirection: "row", display: "flex", padding: 15, justifyContent: "center", alignItems: "center" }}>
          <div style={{ padding: 5, textAlign: "left", width: 500, marginRight: 100 }}>
            <h3 style={{ textAlign: "center" }}>Polyurethane Foaming</h3>
            <p>We are manufacturing PU Foaming components for NVH (Noise, Vibration and Heat) insulation.</p>
            <p>Machine Capacity - 125 kg/hour</p>
          </div>
          <div>
            <img src={Tech4} style={{ height: 200, width: 500 }} alt="Tech4" />
          </div>
        </div>
      </div>

      {/* Major Customers */}
      <div style={{ justifyContent: 'center', alignItems: "center", alignSelf: "center" }}>
        <h1 style={{ textAlign: "center" }}>Some of our Major Customers</h1>
        <img src={Major1} style={{ height: 100, width: 1000, marginTop: 15, marginLeft: 200 }} alt="Major1" />
        <img src={Major2} style={{ height: 100, width: 1000, marginTop: 40, marginLeft: 200 }} alt="Major2" />
      </div>
    </div>
  );
};

export default Home;
